import { Button } from "../../../../components/ui/common/button";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from "../../../../components/ui/common/select";

/** Same page-size choices the legacy `PaginationView` offered. */
const PAGE_SIZE_OPTIONS = [5, 10, 20, 50];

interface UserListPaginationProps {
  totalCount: number;
  pageNumber: number;
  totalPages: number;
  pageSize: number;
  onPageChange: (page: number) => void;
  onPageSizeChange: (size: number) => void;
}

/** Count label on the left; page-size `Select` and Previous/Next on the right (same footer as `CompanyListPagination`). */
const UserListPagination = ({
  totalCount,
  pageNumber,
  totalPages,
  pageSize,
  onPageChange,
  onPageSizeChange
}: UserListPaginationProps) => (
  <div className="tw-mt-3 tw-flex tw-flex-wrap tw-items-center tw-justify-between tw-gap-3">
    <p className="tw-text-xs tw-text-muted-foreground">
      {totalCount} user{totalCount !== 1 ? "s" : ""} found
    </p>
    <div className="tw-flex tw-items-center tw-gap-3">
      <div className="tw-flex tw-items-center tw-gap-2">
        <span className="tw-text-xs tw-text-muted-foreground">Rows per page</span>
        <Select value={String(pageSize)} onValueChange={value => onPageSizeChange(Number(value))}>
          <SelectTrigger className="!tw-h-8 tw-w-[4.5rem] tw-text-sm">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {PAGE_SIZE_OPTIONS.map(size => (
              <SelectItem key={size} value={String(size)}>
                {size}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      {totalPages > 1 ? (
        <div className="tw-flex tw-items-center tw-gap-2">
          <Button variant="outline" size="sm" disabled={pageNumber <= 1} onClick={() => onPageChange(pageNumber - 1)}>
            Previous
          </Button>
          <span className="tw-text-sm tw-text-muted-foreground">
            Page {pageNumber} of {totalPages}
          </span>
          <Button
            variant="outline"
            size="sm"
            disabled={pageNumber >= totalPages}
            onClick={() => onPageChange(pageNumber + 1)}
          >
            Next
          </Button>
        </div>
      ) : null}
    </div>
  </div>
);

export default UserListPagination;
